var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"card-title--clickable",class:_vm.inputClass,on:{"click":function($event){return _vm.updateBlockState(_vm.index, !_vm.blockState)}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-spacer'),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.blockState ? "fas fa-angle-up" : "fas fa-angle-down"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }